
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"height":"7.5","rx":"3.75","width":"7.5","x":"13.875","y":"2.25"}})]),_c('path',{attrs:{"d":"m15.8677 16.2427c-.7026.7024-2.1715 2.1714-3.1824 3.1822-.5858.5859-1.5345.5861-2.1204.0003-.99315-.9932-2.43371-2.4337-3.18254-3.1825-2.34315-2.3432-2.34315-6.1422 0-8.48534 2.34314-2.34315 6.14214-2.34315 8.48534 0 2.343 2.34314 2.343 6.14214 0 8.48534z","fill":"#4a3428"}}),_c('path',{attrs:{"d":"m13.875 12c0 1.2427-1.0073 2.25-2.25 2.25s-2.25-1.0073-2.25-2.25c0-1.2426 1.0073-2.25 2.25-2.25s2.25 1.0074 2.25 2.25z","fill":"#fff"}}),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('rect',{attrs:{"fill":"#4a3428","height":"7.5","rx":"3.75","width":"7.5","x":"13.875","y":"2.25"}}),_c('path',{attrs:{"d":"m16.9899 7.87499c-.0984 0-.1932-.0408-.2635-.11487l-1.4933-1.52458c-.1441-.15191-.1441-.40004 0-.55179.144-.15191.3793-.15191.5233 0l1.2229 1.23943 2.5022-2.67141c.1369-.15929.3724-.17043.5233-.02228.151.14439.1616.39267.0211.55178l-2.762 2.96786c-.0667.07784-.1651.12587-.267.12587z","fill":"#fff"}})]),_c('rect',{attrs:{"height":"9","rx":"4.5","stroke":"#fff","stroke-width":"1.5","width":"9","x":"13.125","y":"1.5"}})])
          )
        }
      }
    